import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Produktionsplan", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
    /*#__PURE__*/_createElementVNode("p", null, " Nationellt Pistolskytte ges ut fyra gånger per år. Nedan hittar ni produktionsplanenen för att lättar kunna besluta vad era annonser skall innehålla. Kanske är utgåva 4 ett perfekt läge att annonsera om möjliga julklappar till skyttar runt om i landet. ")
  ])
], -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", null, "Kommande utgivningar", -1)
const _hoisted_7 = {
  key: 0,
  class: "table table-sm table-striped table-bordered"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Utgåva"),
    /*#__PURE__*/_createElementVNode("th", null, "Manusstopp"),
    /*#__PURE__*/_createElementVNode("th", null, "Utgivningsdatum")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ad_nav = _resolveComponent("ad-nav")!
  const _component_loadspinner = _resolveComponent("loadspinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_ad_nav),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _hoisted_6,
          _createVNode(_component_loadspinner, {
            message: "Hämtar utgåvor...",
            loading: _ctx.state.loading
          }, null, 8, ["loading"]),
          (!_ctx.state.loading)
            ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.plans, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.edition), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.toLocalDateString(item.deadline)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.toLocalDateString(item.print)), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}